import { render, staticRenderFns } from "./ProgressByGoals.vue?vue&type=template&id=71d41c5e&scoped=true"
import script from "./ProgressByGoals.vue?vue&type=script&lang=js"
export * from "./ProgressByGoals.vue?vue&type=script&lang=js"
import style0 from "./ProgressByGoals.vue?vue&type=style&index=0&id=71d41c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d41c5e",
  null
  
)

export default component.exports